import { Box, Paper } from '@mui/material';
import { ReactTable } from '../../../../components/shared';
import { MONTHLY_POSTING_DETAIL_TABLE } from '../../../../constants/tableColumns';
import useStyles from '../style';

const MonthlyPostingDetailTable = ({ rows }) => {
  const classes = useStyles();
  const data = rows ?? [];

  return (
    <Box component={Paper} elevation={0} className={classes.finalizedDetailTableContainer}>
      <ReactTable columns={MONTHLY_POSTING_DETAIL_TABLE} data={data} enableRowClick={false} />
    </Box>
  );
};

export default MonthlyPostingDetailTable;
